let onBestsellersBtn = document.querySelector('.on-bestsellers')

if(onBestsellersBtn) {
    onBestsellersBtn.addEventListener('click', () => {
        let {slug} = onBestsellersBtn.dataset

        onBestsellersBtn.disable(true)
        requestAxios('onBestsellers', {slug}, () => {
            window.location.reload()
        })
    })
}

///

let onNewBtn = document.querySelector('.on-new')

if(onNewBtn) {
    onNewBtn.addEventListener('click', () => {
        let {slug} = onNewBtn.dataset

        onNewBtn.disable(true)
        requestAxios('onNew', {slug}, () => {
            window.location.reload()
        })
    })
}